<template>
<el-dialog title="订单货源码" :visible="erweimaFlag" width="500px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="imgBox" style="margin-left: 110px;">
        <qriously :value="initQCode" :size="250" />
      </div>
      <div style="font-size:18px;" >
        <div style="">
          <span style="font-weight:600;">发布企业：</span><span>{{rowData.createSubcompanyName}}</span>
        </div>
        <div style="">
          <span style="font-weight:600;">发货地：</span><span>{{rowData.deliverAddress}}</span>
        </div>
        <div style="">
          <span style="font-weight:600;">收货地：</span><span>{{rowData.receivingAddress}}</span>
        </div>
        <div style="">
          <span style="font-weight:600;">货物类型：</span><span>{{rowData.productTypeName}}</span>
        </div>
      </div>
      <!-- <div style="font-size:18px;color:red;">
        <span>注意：</span><span>请司机上传有效证件</span>
      </div> -->
      <div style="font-size:18px;color:red;">
        <span>请扫描正确货源码，否则影响运费结算</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" >关闭</el-button>
        <el-button type="primary" @click="editFN" >编辑</el-button>
      </span>
    </el-dialog>
</template>
<script>
import { emptyFn, encryption, dateTimeFormat } from '@/utils/util'
export default {
  name: 'xiugaiSG',
  props: {
    erweimaFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      initQCode: ''
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    let orderBusinessId = '' + this.rowData.orderBusinessId
    let orderId = '' + this.rowData.orderId
    let json = {
      orderBusinessId: orderBusinessId,
      orderId: orderId
    }
    let data = encryption({
      data: json,
      key: this.global.key,
      param: ['orderBusinessId', 'orderId']
    })
    this.initQCode = JSON.stringify(data)
  },
  methods: {
    editFN () {
      this.$parent.shengmaFN(this.rowData)
      this.$emit('update:erweimaFlag', false)
    },
    closeDialog () {
      this.$emit('update:erweimaFlag', false)
    }
  }

}
</script>

<style scoped lang='less'>
#printMe1 {
  font-size: 14px;
  position: relative;
  padding: 10px;
  // margin-bottom: 10px;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;
  .el-form-item span {
    display: inline-block;
    width: 150px;
  }
  .table_title {
    width: 100%;
    height: 40px;
    font-size: 30px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}
ul {
  width: 100%;
  display: flex;
  li {
    list-style: none;
    flex: 1;
    // color: black;
  }
}
</style>
